<script lang="ts">
    import Session from '../Models/Session';
    import { SESSION } from '../Stores/Session';   
    import { ToastContainer, FlatToast }  from "svelte-toasts";
    import Welcome from './Welcome/Welcome.svelte';
    import AppInfo from './AppInfo/AppInfo.svelte';

    const sessionToken = Session.getToken();

    let sessionState: { logged: boolean; };

    SESSION.subscribe(state => sessionState = state);
</script>

<main>
    {#if sessionState.logged}
        <Welcome />
    {/if}
    <slot></slot>
    <ToastContainer placement="bottom-right" let:data={data}>
        <FlatToast {data} />
    </ToastContainer>
    <AppInfo />
</main>

<style type="text/scss">
    main {
        min-width: 100vw;
        min-height: 100vh;
    }
</style>